import React from 'react';
import { motion } from 'framer-motion';
const introPhotos = [{
  src: 'https://cdn.magicpatterns.com/uploads/dT9ca5TJmHe5iJa3FmAtdD/WhatsApp_Image_2026-10-03_at_16.17.33.jpg',
  alt: 'Entry foyer with sculptural timber-clad spiral staircase'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/13KdEbnjt8zLHzMFCbnL54/WhatsApp_Image_2026-10-03_at_16.17.36.jpg',
  alt: 'Double-height bedroom with oak floors and framed treetop view'
}];
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
/**
 * Pair of actual photos directly after the hero.
 */
export function IntroBreaker() {
  return <section className="w-full bg-bg-warm px-6 md:px-14 py-16 md:py-28 relative z-10" data-id="element-109" data-mp="1rsrko8d7w3wt">
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-10 items-start" data-id="element-110" data-mp="25siqvmxhsg09">
        {introPhotos.map((photo, i) => <motion.figure key={photo.src} variants={fadeUp} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className={`overflow-hidden ${i === 1 ? 'sm:mt-20 md:mt-32' : ''}`} data-id="element-111" data-mp="3jbo1g7ox181e" data-mpi={i}>
            <img src={photo.src} alt={photo.alt} loading="lazy" className="w-full aspect-[3/4] object-cover" data-id="element-112" data-mp="1748fn1x4q73" />
          </motion.figure>)}
      </div>
    </section>;
}